import { Easing } from 'motion'

export const EASE_OUT: Easing = [0.22, 1, 0.36, 1]
